module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wd-box"
  }, [_c('div', {
    ref: "listContainer",
    staticClass: "wd-box-container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "wd-user"
  }, [_c('img', {
    staticClass: "wd-user-img",
    attrs: {
      "src": _vm.$store.state.userInfo.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wd-user-content"
  }, [_c('span', {
    staticClass: "wd-user-content-span"
  }, [_vm._v(_vm._s(_vm.$store.state.userInfo.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "wd-user-content-span1"
  }, [_vm._v("ID " + _vm._s(_vm.data.recodeCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wd-user-edit",
    on: {
      "click": _vm.handleShowXgzl
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/xiugaiziliao@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xiugaiziliao')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wd-jb"
  }, [_c('div', {
    staticClass: "wd-jb-left"
  }, [_c('div', {
    staticClass: "wd-jb-left-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/xunibi_32@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("US" + _vm._s(_vm.$t('all.bi')))])]), _vm._v(" "), _c('span', {
    staticClass: "wd-jb-left-span"
  }, [_vm._v(_vm._s(_vm.data ? _vm.data.virtualBalance : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "wd-jb-right",
    on: {
      "click": _vm.handleShowXfmx
    }
  }, [_vm._v(_vm._s(_vm.$t('all.xiaofeimingxi')))])]), _vm._v("\n\t\t<"), _c('div', {
    staticClass: "wd-box-title"
  }, [_c('span', {
    staticClass: "wd-box-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('span', {
    staticClass: "wd-box-title-span1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wd-box-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('zbList', {
      key: index,
      attrs: {
        "data": item,
        "type": 1
      }
    })
  }), 1), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 1), _vm._v(" "), _c('xiaofeimingxi', {
    ref: "xfmx"
  }), _vm._v(" "), _c('xiugaiziliao', {
    ref: "xgzl"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24234428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/wode/wode.vue
// module id = 802
// module chunks = 1